import{createContext as t}from"react";const r=t({strict:!1});export{r as LazyContext};
